import { Box, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

interface LensTimelineBarChartProps {
  labels: string[];
  avgScores: (number | null)[];
}

const LensTimelineBarChart = ({ labels, avgScores }: LensTimelineBarChartProps) => {
  if (labels.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        <Typography variant="body2" color="text.secondary">
          No data to display
        </Typography>
      </Box>
    );
  }

  return (
    <BarChart
      xAxis={[
        {
          scaleType: "band",
          data: labels,
          label: "Date"
        }
      ]}
      yAxis={[
        {
          min: 0,
          max: 5,
          label: "Score"
        }
      ]}
      series={[
        {
          type: "bar",
          data: avgScores,
          label: "Average Score",
          color: "#1976d2"
        }
      ]}
      margin={{ top: 20, right: 20, bottom: 70, left: 60 }}
      slotProps={{
        legend: {
          direction: "row",
          position: { vertical: "bottom", horizontal: "middle" },
          padding: 0
        }
      }}
    />
  );
};

export default LensTimelineBarChart;
